import { isString, isNumber } from 'lodash';
export const commonListDefaultIteratees = ['sequence', 'name'];
export const commonTreeDefaultIteratees = [
    'treeSequence.parentSequence',
    'treeSequence.sequence',
];
export const defaultSortingIteratees = [
    ...commonTreeDefaultIteratees,
    ...commonListDefaultIteratees,
];
export function naturalAlphanumericSortingCompare(a, b) {
    if (!a || !b) {
        return;
    }
    if (isString(a)) {
        return a.localeCompare(b, undefined, {
            numeric: true,
            sensitivity: 'base',
        });
    }
    if (isNumber(a)) {
        return a - b;
    }
    return undefined;
}
export const defaultSortingOrders = ['asc', naturalAlphanumericSortingCompare];
export default {
    iteratees: defaultSortingIteratees,
    orders: defaultSortingOrders,
};
